import { render, staticRenderFns } from "./WaterModuleInsights.vue?vue&type=template&id=3bc6deb9"
import script from "./WaterModuleInsights.vue?vue&type=script&lang=js"
export * from "./WaterModuleInsights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports